export default {
    fontSize: 8,
    fontWeight: 600,
    position: 'absolute',
    top: -8,
    right: 3,
    color: '#1f242a'
};



// WEBPACK FOOTER //
// ./src/lib/customStyles/badgeStyle.js